var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#66a9f4;}")),React.createElement("path",{"className":"a","d":"M23,1C15.106,1,8.75,6.839,8.75,14.091v5.936A16.585,16.585,0,0,0,4,31.545C4,41.185,12.507,49,23,49s19-7.815,19-17.455a16.585,16.585,0,0,0-4.75-11.518V14.091C37.25,6.839,30.894,1,23,1Zm0,4.364c5.406,0,9.5,3.761,9.5,8.727v2.357a20.327,20.327,0,0,0-19,0V14.091C13.5,9.125,17.594,5.364,23,5.364ZM23.1,25a4.57,4.57,0,0,1,4.653,4.359,4.31,4.31,0,0,1-2.375,3.754v4.973a2.384,2.384,0,0,1-4.75,0V33.118A4.213,4.213,0,0,1,18.4,28.268,4.606,4.606,0,0,1,21.97,25.1,5.342,5.342,0,0,1,23.1,25Z","transform":"translate(-4 -1)","key":1})]);
}

Lock.defaultProps = {"width":"38","height":"48","viewBox":"0 0 38 48"};

module.exports = Lock;

Lock.default = Lock;
